/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */
import React from 'react';
import './DIYStatusPage.scss';
import {Button, Icon} from "@scuf/common";
import DIYAppConstants from "../../utils/DIYAppConstants";
import './ContactSupport.scss';

/**
 * The properties for the Contact Support page.
 *
 */
export interface IContactSupportProps {
  supportEmail?: string;
  supportPhoneNumbers?: Array<string>;
  onClose: () => void;
}

/**
 * This component represents the functional react component for the Contat support page
 * It has an email that can be referenced for support
 * @constructor
 */
export const ContactSupport = (props: IContactSupportProps) => {

  const CONTACT_SUPPORT_TITLE = 'Contact Support';

  /**
   * Get the message for contact support.
   * @returns {string}
   */
  const getContactSupportMessage = () => {
    let emailMessage = `${props.supportEmail}`;
    return <div>
      <div>Get in touch with us at</div>
      <div>Email:&nbsp;&nbsp; <a href='#'>{emailMessage}</a></div>
      <div className='cntct-sprt-tel-phnum'>
        Tel no:&nbsp;&nbsp;
        <span className='ph-num-holder'>
        {
          props.supportPhoneNumbers && props.supportPhoneNumbers.map((phNumber,index) => {
          return <span><a href='#'>{`${phNumber}`}</a>{index<props.supportPhoneNumbers!.length-1?",":""} </span>;
          })
        }
        </span>       
      </div>
      <div className='option-msg'><div>Please choose Option #3</div></div>
    </div>;
  };

  const getNavigationElement = () => {
    return <div className="ui-contact-supp-navigation">
      <Button type="secondary"
              onClick={() => {
                props.onClose();
              }}
              content="Cancel"/>
    </div>;
  };

  const getContatSupportContent = () => {
    return <div className='ui-diy-status-root'>
      <div className='ui-status-page-title'>
        {CONTACT_SUPPORT_TITLE}
      </div>
      <div className='ui-diy-status-icon'>
        <Icon name='message-dialog' exactSize={128}
              root='common'
              color={DIYAppConstants.CONTACT_SUPPORT_COLOR}/>
      </div>
      <div className='ui-diy-status-msg ui-conct-sprt-msg'>
        {getContactSupportMessage()}
      </div>
    </div>
  };

  return <React.Fragment>
    <div className={`application-page-content contact-support-container`}>
      {getContatSupportContent()}
    </div>
    <div className='application-navigation ui-box-shadow'>
      {getNavigationElement()}
    </div>
  </React.Fragment>;
};
